import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';
import { useAppDispatch } from '../../../pages/assessment';
import { setGuardians } from '../../../redux/assessment';
import { updateMeta } from '../../../redux/meta';
import { rules } from './rules';
import { AssessmentButtons, AssessmentCard } from '../shared';

type ConsentForMinorFormValues = {
  consentForMinor: boolean;
};

const ConsentForMinor = () => {
  const dispatch = useAppDispatch();

  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isValid },
  } = useForm<ConsentForMinorFormValues>();

  const onSubmit: SubmitHandler<ConsentForMinorFormValues> = async data => {
    const payload = { primary: { consentForMinor: data.consentForMinor } };
    dispatch(setGuardians(payload));
    dispatch(updateMeta());
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <AssessmentCard>
        <Controller
          name="consentForMinor"
          control={control}
          defaultValue={false}
          rules={rules.consentForMinor as any}
          render={({ field, fieldState }) => (
            <FormControl error={!!fieldState.error}>
              <FormControlLabel
                control={<Checkbox {...field} />}
                label="By checking this box, you consent to treatment as a parent, legal guardian, or other legal representative."
              />
              {fieldState.error && (
                <FormHelperText sx={{ ml: 4 }}>
                  {fieldState.error.message}
                </FormHelperText>
              )}
            </FormControl>
          )}
        />
      </AssessmentCard>
      <AssessmentButtons
        primary={{
          children: 'Continue',
          disabled: isSubmitting || !isValid,
          type: 'submit',
        }}
      />
    </form>
  );
};

export default ConsentForMinor;
